import { store } from "@/store/store";
import { centros } from "@/shared/dtos/centros";
import {
  VuexModule,
  Mutation,
  getModule,
  Module,
  Action,
} from "vuex-module-decorators";
import { ssmHttpService } from "@/shared/services/http-service";
import { API } from "@/shared/api";

@Module({
  namespaced: true,
  name: "centrosModule",
  store,
  dynamic: true,
})
class centrosModule extends VuexModule {
  public centros: centros[] = [];
  public centro: centros = new centros();

  @Action({ commit: "onGetcentros" })
  public async getcentros() {
    return await ssmHttpService.get(API.centros);
  }

  @Action({ commit: "onGetcentro" })
  public async getcentro(id: any) {
    return await ssmHttpService.get(API.centros + "/" + id);
  }

  @Action
  public async guardarcentro(item: centros) {
    return await ssmHttpService.post(
      API.centros,
      item.toJson([
        "created_at_utc",
        "updated_at_utc",
        "created_by_user_id",
        "updated_by_user_id",
      ])
    );
  }

  @Action
  public async modificarcentro(item: centros) {
    return await ssmHttpService.put(
      API.centros + "/" + item.id,
      item.toJson([
        "created_at_utc",
        "updated_at_utc",
        "created_by_user_id",
        "updated_by_user_id",
      ])
    );
  }

  @Action
  public async eliminarcentro(item: centros) {
    return await ssmHttpService.delete(API.centros + "/" + item.id, null, false);
  }

  @Mutation
  public onGetcentros(res: centros[]) {
    this.centros = res ? res.map((x) => new centros(x)) : [];
  }

  @Mutation
  public onGetcentro(res: centros) {
    this.centro = new centros(res);
  }
}

export default getModule(centrosModule);
